module.exports = __webpack_public_path__ + "static/the-spark-7342b1a95e563fdfe7ac252b990f2e28.png";